import $ from 'jquery'

export default function(o){

  var reset = function(){
    div.empty()
  }

  var update = function(){
    if(o.video){
      var total = o.video.buffered.length
      div.empty()
      for (var i = total - 1; i >= 0; i--) {
        try{
          var start = o.video.buffered.start(i)
          var end = o.video.buffered.end(i)
          var length = o.video.duration
          var left = Math.round(start / length * 400 * 100) / 100
          var width = Math.round((end - start) / length * 400 * 100) / 100
          div.append([
            $('<div>')
            .css({
              position: 'absolute',
              height: '34px',
              left: `${left}px`,
              width: `${width}px`,
              background: 'white',
              opacity: '0.02',
              pointerEvents: 'none',
            })
          ])
        } catch(e){
          return
        }
      }
    }
    requestAnimationFrame(update)
  }

  requestAnimationFrame(update)

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      left: 0,
      right: 0,
      height: '34px',
      pointerEvents: 'none',
    })

  div.reset = reset

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/timeline/buffered/buffered.js